import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../../utilerias/constantes/urlconstantes";
import { Nodo, OrganigramaRes } from "../../shared/model/organigrama/organigrama.model";

@Injectable({
  providedIn: "root",
})
export class OrganigramaService {
  constructor(private http: HttpClient) {}

  /** El árbol, las personas y las áreas en una sola llamada. */
  consultar(): Observable<OrganigramaRes> {
    return this.http.post<OrganigramaRes>(UrlConstantes.ORGANIGRAMA_CONSULTAR, {});
  }

  guardar(nodo: Nodo): Observable<OrganigramaRes> {
    return this.http.post<OrganigramaRes>(UrlConstantes.ORGANIGRAMA_GUARDAR, { nodo });
  }

  /**
   * Cuelga un puesto de otro jefe.
   *
   * `sincronizaVacaciones` decide si además cambia quién le autoriza
   * los días. Va explícito y no por omisión: es un efecto real sobre
   * otro módulo y quien mueve tiene que haberlo dicho.
   */
  mover(
    idNodo: number,
    idPadre: number,
    sincronizaVacaciones: boolean
  ): Observable<OrganigramaRes> {
    return this.http.post<OrganigramaRes>(UrlConstantes.ORGANIGRAMA_MOVER, {
      idNodo,
      idPadre,
      sincronizaVacaciones,
    });
  }

  eliminar(idNodo: number): Observable<OrganigramaRes> {
    return this.http.post<OrganigramaRes>(UrlConstantes.ORGANIGRAMA_ELIMINAR, { idNodo });
  }

  /** Los últimos movimientos, más recientes primero. */
  historial(): Observable<OrganigramaRes> {
    return this.http.post<OrganigramaRes>(UrlConstantes.ORGANIGRAMA_HISTORIAL, {});
  }
}
